module.exports = __webpack_public_path__ + "img/housingmatchmark.d70cf91d.png";